var path = '/templates/core/components/month_chooser/month_chooser.html';
var html = "<a class=\"btn btn-sm btn-default\" ng-click=$ctrl.goToPrev() ng-disabled=!$ctrl.prevMonth>{{ 'sharedModules.core.components.monthChooser.sengetsu' | translate }}</a> <a class=\"btn btn-sm btn-default\" ng-click=$ctrl.goToNext() ng-disabled=!$ctrl.nextMonth>{{ 'sharedModules.core.components.monthChooser.yokugetsu' | translate }}</a>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ../app_shared/src/shared_modules/core/components/month_chooser/month_chooser.html
// module id = 1311
// module chunks = 0